export default __webpack_public_path__ + "static/media/Landscape.abcde2ac.png";